import { LabelInput } from '../../../../components/Input/Input';
import DigitalSignature from '../../../../screens/ModalExternalOS/components/DigitalSignature/DigitalSignature';

export const AuthorizationTerm = (props) => {
  const {
    values,
    company,
    printCompany,
    onChange,
    localSignatureData,
    setLocalSignatureData,
    isSignatureReset,
    setIsSignatureReset,
    onSaveBeforeSignature,
  } = props;

  return (
    <div>
      <LabelInput
        className="remove-margin"
        type={'textarea'}
        inputClassname={'os-notes-textarea'}
        onChange={(value) => onChange('authorizationTerm', value)}
        value={
          values?.authorizationTerm ||
          printCompany?.authorizationTerm ||
          company?.authorizationTerm ||
          ''
        }
      />

      {/* Assinatura Digital */}
      <DigitalSignature
        values={values}
        localSignatureData={localSignatureData}
        setLocalSignatureData={setLocalSignatureData}
        isSignatureReset={isSignatureReset}
        setIsSignatureReset={setIsSignatureReset}
        checkboxLabel="Cliente autorizou"
        onSaveBeforeSignature={onSaveBeforeSignature}
      />
    </div>
  );
};
